import { errorValidation } from './utils';

let registerPhone = $('#register_phone');

/**
 * Init intlTelInput
 */
[registerPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateRegisterPhone',
	function () {
		if (registerPhone.intlTelInput('isValidNumber')) {
			return true;
		} else {
			return false;
		}
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Register
	$("form[name='register']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'register[name]': {
				required: true,
			},
			'register[city]': {
				required: true,
			},
			'register[email]': {
				required: true,
				email: true,
			},
			'register[phone]': {
				required: true,
				// validateRegisterPhone: true,
			},
			'register[password]': {
				required: true,
			},
			'register[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
			'register[terms]': {
				required: true,
			},
		},
		messages: {
			'register[name]': {
				required: window.translations.required,
			},
			'register[city]': {
				required: window.translations.required,
			},
			'register[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'register[phone]': {
				required: window.translations.required,
			},
			'register[password]': {
				required: window.translations.required,
			},
			'register[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
			'register[terms]': {
				required: window.translations.checkboxRequired,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
